import { OptionType } from '@/typings/common';

import { INITIAL_FORM_VALUES } from './ApplicationForCar.constans';

export const getDefaultValues = (options: {
  dealers: OptionType[];
}): typeof INITIAL_FORM_VALUES => {
  const dealer =
    options?.dealers.length === 1
      ? options.dealers[0].value
      : INITIAL_FORM_VALUES.dealer;

  return {
    ...INITIAL_FORM_VALUES,
    dealer: dealer,
  };
};
